/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-debugger */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-continue */
/* eslint-disable no-plusplus */
/* eslint-disable no-console */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable array-callback-return */
// Librerias
import { useState, useMemo, useContext } from "react";
import { useLocation } from "react-router-dom";

// Otros
import FiltersContext from "../context/FiltersContext";
import returnDateText from "../helpers/ReturnDateText";

/**
 * Descripcion del hook: Este hook se encarga de filtrar y retornar los datos con la respuesta seleccionada.
 *
 * Implementacion: Se importa el hook y se extrae los siguientes elementos, se debe pasar la lista de los elementos que se quieren filtrar.
 *
 *  const { appliedFilters, setAppliedFilters, filteredPackets } = useFilterPackages(data);
 *
 *
 * Bugs: Qué bugs se han presentado y como se solucionan.
 */

const useFilterPackages = (items) => {
  const urlLocation = useLocation();
  const query = new URLSearchParams(urlLocation.search); // Nos trae los parámetros de la url, query.get()

  const [appliedFilters, setAppliedFilters] = useState({
    event: query.get("event") || "",
    location: query.get("country") || "",
    month: "",
    year: "",
  });
  const [filteredPackets, setFilteredPackets] = useState([]);

  const { setFilters } = useContext(FiltersContext);

  const { event, location, month, year } = appliedFilters;
  const resultados = [];

  useMemo(() => {
    for (let index = 0; index < items?.length; index++) {
      const paquete = items[index];

      let hasCategory = true;
      let hasLocation = true;
      let hasMonth = true;
      let hasYear = true;

      if (event !== "") {
        if (paquete.category !== event) {
          hasCategory = false;
        }
      }

      // Hay un deporte o categoria?
      if (hasCategory) {
        if (location !== "") {
          if (paquete.location !== location) {
            hasLocation = false;
          }
        }
      } else {
        continue;
      }

      // Hay una ubicacion?
      if (hasLocation) {
        if (month !== "") {
          if (returnDateText(paquete.date).month !== month) {
            hasMonth = false;
          }
        }
      } else {
        continue;
      }

      // Hay un mes?
      if (hasMonth) {
        if (year !== "") {
          if (returnDateText(paquete.date).year !== year) {
            hasYear = false;
          }
        }

        if (hasYear) {
          resultados.push(paquete);
        } else {
          continue;
        }
      } else {
        continue;
      }
    }

    if (event === "" && location === "" && month === "" && year === "") {
      setFilteredPackets(items);
    }
    else if (event === undefined) {
      setFilteredPackets(items);
    }
    else {
      setFilteredPackets(resultados);
    }

    setFilters({ event: event || "", country: location });
  }, [items, appliedFilters]);

  return { appliedFilters, setAppliedFilters, filteredPackets };
};

export default useFilterPackages;
